/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'dva';
import { Tabs } from 'antd';
import Container from '@/components/Container';
import TalentPool from './talentPool'
import DutyArea from './dutyArea'
import styles from './index.less';

const { TabPane } = Tabs;


class Statistic extends Component {
  constructor(props) {
    super(props);

  }

  tabsChange = key => {
    console.log(key);
  }


  render() {


    return (
      <Container breStates={!0} version={2}>
        <div className={styles.root}>
          <Tabs onChange={this.tabsChange} type="card">
            <TabPane tab="人才库" key="1">
              <TalentPool />
            </TabPane>
            <TabPane tab="责任区" key="2">
              <DutyArea />
            </TabPane>
          </Tabs>
        </div>
      </Container>
    );
  }
}

export default Statistic
